import { User } from '../models';

export class AppLocalStorage {
  static get authToken(): string {
    return localStorage.getItem('auth_token');
  }

  static set authToken(token: string) {
    localStorage.setItem('auth_token', token);
  } 

  static clear() {
    localStorage.removeItem('auth_token');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/helpers/app-local-storage.ts